import React, { useId } from 'react';
import { Button, Dialog, DialogBody, DialogFooter, DialogHeader } from '../ui';

type Props = {
  open: boolean;
  title?: string;
  message: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
};

export const ConfirmModal: React.FC<Props> = ({
  open,
  title = 'Confirm Delete',
  message,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const titleId = useId();
  // While the action runs the dialog stays put, as the Cancel button is disabled too
  const close = () => {
    if (!loading) onCancel();
  };

  return (
    <Dialog open={open} onClose={close} labelledBy={titleId} handle className="sm:max-w-md">
      <DialogHeader id={titleId} title={title} className="max-sm:pt-1" />
      <DialogBody className="pb-5 pt-2 text-[13px] leading-relaxed text-neutral-600">{message}</DialogBody>
      <DialogFooter>
        <Button variant="secondary" onClick={close} disabled={loading} className="h-11 flex-1 sm:h-9 sm:flex-none">
          {cancelText}
        </Button>
        <Button variant="primary" onClick={onConfirm} loading={loading} className="h-11 flex-1 sm:h-9 sm:flex-none">
          {confirmText}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
